import React from 'react';
import {
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Col,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';
import Moment from 'react-moment';

class TimesheetLocationDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activity_data: {},
      checkInLocation: '',
      checkInDate: '',
      checkInImage: '',
      checkOutLocation: '',
      checkOutDate: '',
      checkOutImage: '',
    };
  }

  getCurrentDate(date) {
    let newDate = new Date(date);

    let day = newDate.getUTCDate();
    let month = newDate.getUTCMonth() + 1;
    let year = newDate.getUTCFullYear();

    let hour = newDate.getUTCHours();
    let minute = newDate.getUTCMinutes();

    if (month < 10) month = '0' + month;
    if (day < 10) day = '0' + day;

    if (hour < 10) hour = '0' + hour;
    if (minute < 10) minute = '0' + minute;

    return year + '-' + month + '-' + day + ' ' + hour + ':' + minute;
  }

  componentDidMount() {
    console.log(this.props);
    if (
      this.props.data.timesheetId !== null ||
      this.props.data.timesheetId !== ''
    ) {
      let id = this.props.data.timesheetId;
      let act = this.props.data.timesheetList.find(
        e => e.checkin_ref === id || e.checkout_ref === id,
      );

      this.setState({
        activity_data:
          this.props.data.mode === 'CheckIn'
            ? act.checkin_data.length > 0
              ? JSON.parse(act.checkin_data)
              : act.checkin_data
            : act.checkout_data.length > 0
            ? JSON.parse(act.checkout_data)
            : act.checkout_data,
        checkInLocation: act.checkin_location,
        checkInDate: act.checkin_dt ? act.checkin_dt : '',
        checkInImage: act.checkin_image,
        checkOutLocation: act.checkout_location,
        checkOutDate: act.checkout_dt ? act.checkout_dt : '',
        checkOutImage: act.checkout_image,
      });
    }
  }

  render() {
    const {
      activity_data,
      checkInLocation,
      checkInDate,
      checkInImage,
      checkOutLocation,
      checkOutDate,
      checkOutImage,
    } = this.state;
    return (
      <>
        <ModalHeader toggle={this.props.onToggleModal()}>
          Timesheet Information
        </ModalHeader>
        <ModalBody className="ps-modal-display">
          <Row>
            {this.props.data.mode === 'CheckIn' && checkInImage !== null && (
              <Col md={12}>
                <Label>Check-In Image</Label>
                <div
                  className={`ps-photo ${
                    checkInImage.length < 1 ? ' empty' : ''
                  }`}
                >
                  <div className="image">
                    <img src={checkInImage} alt="Check In Image" />
                  </div>
                </div>
              </Col>
            )}
            {this.props.data.mode === 'CheckIn' && (
              <>
                <Col md={6}>
                  <Label>Check-In Date</Label>
                  <p>
                    {checkInDate.length > 0
                      ? this.getCurrentDate(checkInDate)
                      : 'No Data'}
                  </p>
                </Col>
                <Col md={6}>
                  <Label>Check-In Location</Label>
                  <p>{checkInLocation === '' ? 'None' : checkInLocation}</p>
                </Col>
              </>
            )}
            {this.props.data.mode === 'CheckOut' && checkOutImage !== null && (
              <Col md={12}>
                <Label>Check-Out Image</Label>
                <div
                  className={`ps-photo ${
                    checkOutImage.length < 1 ? ' empty' : ''
                  }`}
                >
                  <div className="image">
                    <img src={checkOutImage} alt="Check In Image" />
                  </div>
                </div>
              </Col>
            )}
            {this.props.data.mode === 'CheckOut' && (
              <>
                <Col md={6}>
                  <Label>Check-Out Date</Label>
                  <p>
                    {checkOutDate.length > 0
                      ? this.getCurrentDate(checkOutDate)
                      : 'No Data'}
                  </p>
                </Col>
                <Col md={6}>
                  <Label>Check-Out Location</Label>
                  <p>{checkOutLocation === '' ? 'None' : checkOutLocation}</p>
                </Col>
              </>
            )}

            {Object.keys(activity_data).map(function (key, index) {
              return (
                <Col md={6} key={index}>
                  <Label>{key[0].toUpperCase() + key.slice(1)}</Label>
                  <p>
                    {activity_data[key] === null ? 'No' : activity_data[key]}
                  </p>
                </Col>
              );
            })}
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button
            className="theme-button theme-button-secondary"
            onClick={this.props.onToggleModal()}
          >
            Close
          </Button>
        </ModalFooter>
      </>
    );
  }
}

export default TimesheetLocationDetails;
